import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (authError) {
      setError('E-mail ou senha incorretos. Verifique e tente novamente.');
      return;
    }

    navigate('/admin');
  };

  return (
    <main
      className="min-h-screen bg-[#0A1829] flex items-center justify-center px-4"
      style={{ fontFamily: '\'Cormorant Garamond\', serif' }}
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-2">
            <span className="h-px w-8 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.25em] uppercase">
              Acesso restrito
            </span>
            <span className="h-px w-8 bg-[#B39B62]"></span>
          </div>
          <h1 className="text-white text-3xl font-light" style={{ fontFamily: '\'Cormorant Garamond\', serif' }}>
            Moreira Tófoli
          </h1>
          <p className="text-white/40 font-sans text-xs mt-1 tracking-widest uppercase">Advogados</p>
        </div>

        {/* Card */}
        <div className="bg-white/5 border border-white/10 rounded-lg p-8">
          <h2 className="text-white text-xl font-light mb-1" style={{ fontFamily: '\'Cormorant Garamond\', serif' }}>
            Painel Administrativo
          </h2>
          <p className="text-white/40 font-sans text-xs mb-8">Entre com suas credenciais para continuar</p>

          {error && (
            <div className="bg-red-500/10 border border-red-500/30 rounded-md px-4 py-3 mb-6 flex items-center gap-3">
              <i className="ri-error-warning-line text-red-400 text-sm"></i>
              <p className="text-red-400 font-sans text-xs">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-white/60 font-sans text-xs font-semibold tracking-wider uppercase mb-2">
                E-mail
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-white/5 border border-white/15 rounded-md px-4 py-3 text-white placeholder-white/25 font-sans text-sm focus:outline-none focus:border-[#B39B62]/50 transition-colors"
                placeholder="seu@email.com"
              />
            </div>

            <div>
              <label className="block text-white/60 font-sans text-xs font-semibold tracking-wider uppercase mb-2">
                Senha
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-white/5 border border-white/15 rounded-md px-4 py-3 text-white placeholder-white/25 font-sans text-sm focus:outline-none focus:border-[#B39B62]/50 transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-sm py-3 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2 mt-2"
            >
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin text-base"></i>
                  Entrando...
                </>
              ) : (
                <>
                  <i className="ri-lock-unlock-line text-base"></i>
                  Entrar
                </>
              )}
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <a
            href="/"
            onClick={(e) => { e.preventDefault(); navigate('/'); }}
            className="text-white/30 hover:text-white/50 font-sans text-xs cursor-pointer transition-colors"
          >
            ← Voltar ao site
          </a>
        </div>
      </div>
    </main>
  );
}
